export enum TipoAvatarEnum {
  Padrao = 'mp-avatar-padrao',
  Sigla = 'mp-avatar-sigla',
  Icone = 'mp-avatar-icone',

}
